/**
 * Universal Link / App Link shim host. Only the production app is
 * cryptographically associated with this domain, so a tap always resolves to the
 * production app or the production store listing — never anything staging
 * specific. See the "Open App Banner" page of the b2c-native-app wiki.
 * Mirrors REDIRECT_BASE_URL in b2c-native-app/src/constants/foorban.ts.
 */
export const REDIRECT_BASE_URL = 'https://redirect.foorban.business';

/**
 * Universal Link / App Link shim URL. A genuine tap on an <a> pointing here
 * lets the OS open the native app directly if installed; otherwise the shim
 * page loads and redirects to the right store based on UA (see
 * redirect.foorban.business's script). Must never be triggered via
 * `window.location` / onClick-only handlers — iOS only honors real anchor taps.
 * We don't bother mirroring the current path/query: landing on the app's home
 * screen is an acceptable fallback, so the shim root is always used.
 *
 * `?env=` is inert on mobile — the shim only reads it on its desktop branch,
 * and neither the banner nor the dialog renders on desktop. It's kept for
 * parity with the native app's banner.
 */
export function buildShimUrl(): string {
	const env = process.env.REACT_APP_ENV;
	return `${REDIRECT_BASE_URL}/${env ? `?env=${env}` : ''}`;
}

/** Key used to persist the day the banner was dismissed. */
export const OPEN_APP_BANNER_DISMISSED_STORAGE_KEY = 'openAppBannerDismissedDate';
